/**
 * @author 贝才[beica1@outook.com]
 * @date 2021/3/1
 * @description
 *   alert.ts of WeTrade
 */
import { showAlert } from '@/components/popup/popup'

export default showAlert
